export function formatDateTime(value, locale) {
    if (!value) return '—';
    return new Date(value).toLocaleString(locale);
}

// Turns HTML entities (e.g. "confirmaci&oacute;n") into plain text. The result is only ever
// rendered as a React text node, never injected as HTML, so scraped input stays inert.
export function decodeHtmlEntities(value) {
    if (!value) return '';
    return new DOMParser().parseFromString(value, 'text/html').documentElement.textContent ?? '';
}

export function formatAmount(value, locale) {
    if (value === undefined || value === null) return '—';
    return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
}
